import { render, staticRenderFns } from "./roomTypeList.vue?vue&type=template&id=041dea81&scoped=true"
import script from "./roomTypeList.vue?vue&type=script&lang=js"
export * from "./roomTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041dea81",
  null
  
)

export default component.exports